import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { Input, SelectPicker } from "rsuite";
import Pagination from "rsuite/Pagination";
import { APi } from "../../../Api";
import Grid from "../../../Components/Grid";
import format_number from "../../../Helpers/number_formatter";
import { balanceClientAtom } from "../../../Atoms/balance.client.atom";
import Responsive from "../../../Components/Responsive";
import ListTransactions from "../../JournalCheckout/ListTransactions";
import { TypeClient } from "../../../Constants/types";
import Label from "../../../Components/Label";
import { userAtom } from "../../../Atoms/user.atom";
import { checkoutsAtom } from "../../../Atoms/checkouts.atom";
import TransactionParentModal from "../../../Components/modal/TransactionParent";

const BalanceClient = (props) => {
  const [data, setdata] = useRecoilState(balanceClientAtom);
  const [show, setShow] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [type, setType] = useState(0);
  const user = useRecoilValue(userAtom);
  const [checkouts, setcheckouts] = useRecoilState(checkoutsAtom);
  const [showB2C, setShowB2C] = useState(false);

  const [filterModel, setfilterModel] = useState({
    q: "",
    page: 1,
    take: 20,
    id: props.checkoutId || null,
    name: "",
  });

  const fetch = (filterModel, type) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction + "/GetTransactionsClients",
      { ...filterModel, type }
    )
      .fetchAll()
      .then((res) => {
        setdata(res.data.data);
        setTotalCount(res.data.totalCount);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const displayAction = (id) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/GetClientDetails", {
      id,
      type,
      checkoutId: filterModel.id,
    })
      .fetchAll()
      .then((res) => {
        console.log(res.data, "res.data");
        setTransactions(res.data);
      })
      .catch((e) => {
        console.error(e);
        setTransactions([]);
      });
  };

  useEffect(() => {
    fetch(filterModel, type);
  }, [filterModel, type]);

  return (
    <div>
      <Responsive m={12} l={12} xl={12} className="p-5">
        <label>Recherche: </label>
        <Input
          placeholder="recherche"
          onChange={(name) => {
            setfilterModel((prev) => {
              return { ...prev, name };
            });
          }}
        />
      </Responsive>

      <Responsive m={3} l={3} xl={3} className="p-5">
        <Label>Type Client : </Label>
        <SelectPicker
          data={TypeClient}
          block
          noSearch
          value={type}
          onSelect={(type) => {
            setType(type);
          }}
        />
      </Responsive>

      {user && !props.checkoutId && (
        <Responsive m={3} l={3} xl={3} className="p-5">
          <label>Caisse: </label>
          <SelectPicker
            data={[{ label: "Tout", value: null }].concat(
              checkouts.map((el) => {
                return { value: el.id, label: el.name.toUpperCase() };
              })
            )}
            block
            noSearch
            value={filterModel.id}
            onSelect={(id) => {
              setfilterModel((prev) => {
                return { ...prev, id };
              });
            }}
          />
        </Responsive>
      )}

      <Grid
        actionKey="id"
        columns={columns}
        rows={data}
        displayAction={(id) => {
          if (type !== 0) {
            setShow(true);
          } else {
            setShowB2C(true);
          }
          displayAction(id);
        }}
        noAdvancedActions
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            window.scrollTo(0, 0);
            setfilterModel((prev) => {
              return { ...prev, page };
            });
          }}
          onChangeLimit={(take) => {
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
          }}
        />
      </div>
      <ListTransactions
        show={show}
        close={() => setShow(false)}
        data={transactions}
      />
      <TransactionParentModal
        open={showB2C}
        handleClose={() => setShowB2C(false)}
        data={transactions}
      />
    </div>
  );
};

const columns = [
  {
    value: "name",
    name: "Nom",
    render: (v) => <a>{v ? v.toUpperCase() : "-"}</a>,
  },
  {
    value: "debit",
    name: "Total Debit",
    render: (v) => <b style={{ fontSize: "14px" }}>{format_number(v)}</b>,
  },

  {
    value: "credit",
    name: "Total Credit",
    render: (v) => <b style={{ fontSize: "14px" }}>{format_number(v)}</b>,
  },

  {
    value: "balance",
    name: "Balance",
    render: (v) => (
      <b
        style={{
          fontSize: "14px",
          color: v < 0 ? "#633" : "#549f0a",
        }}
      >
        {format_number(v)}
      </b>
    ),
  },
  {
    value: "checkoutName",
    name: "Caisse",
    render: (v) => (
      <b style={{ color: "#4c67c2" }}>{v ? v.toUpperCase() : "TOUT"}</b>
    ),
  },
];

export default BalanceClient;
